import { Component, OnInit } from '@angular/core';
import { DataModelService } from '@services/data-model.service';
import { Router } from '@angular/router';
import { FontawesomeListService } from '@scaffold/services/fontawesome-list.service';
import { NotificationsService } from '@services/notifications.service';

@Component({
    selector: 'app-new-data-category',
    templateUrl: './new-data-category.component.html',
    styleUrls: [
        '../data-model-prefs/data-model-prefs.component.scss',
        './new-data-category.component.scss',
    ],
    standalone: false
})
export class NewDataCategoryComponent implements OnInit {
  newCat = '';
  catList = [];
  previewList = [];
  iconCategories = [];
  selectedIcon;

  selectedCategory;

  constructor(
    private dataModelService: DataModelService,
    private router: Router,
    private notifications: NotificationsService,
    private icons: FontawesomeListService
  ) {}

  ngOnInit() {
    this.iconCategories = this.icons.catagories;
    this.getCategories();

    this.dataModelService.updateTypeListTrigger().subscribe(() => {
      this.getCategories();
    });
  }

  getCategories() {
    this.dataModelService.getCategories().subscribe(list => {
      this.catList = list;
    });
  }

  getIconHtml(icon) {
    return '<i class="' + icon + '"></i>';
  }

  createCategory() {
    if (!this.alreadyExists() && this.newCat != '') {
      this.dataModelService
        .createCategory(this.newCat, this.selectedIcon)
        .subscribe(data => {
          if (data.errorMessage) {
            this.notifications.popNotification(data.errorMessage, 'X');
          } else {
            this.newCat = '';
            this.selectedIcon = null;
            this.selectedCategory = null;

            this.dataModelService.updateTypes();
            // this.router.navigateByUrl('/data-models');
          }
        });
    }
  }

  alreadyExists() {
    var catExists = false;

    for (var i = 0; i < this.catList.length; i++) {
      var cat = this.catList[i];

      if (this.newCat + '__c' == cat.title) {
        catExists = true;
        break;
      }
    }

    return catExists;
  }

  previewCat() {
    if (this.newCat && this.selectedIcon) {
      this.previewList = [
        {
          label: this.newCat,
          icon: this.selectedIcon,
          items: [{ label: 'Item 1' }, { label: 'Item 2' }],
        },
      ];
    }
  }
}
